<template>
  <button
    type="submit"
    data-test="next-button"
    class="
      buttonNext
      flex
      relative
      justify-center
      md:w-full
      font-thin
      py-4
      px-6
      text-2xl
      transition
      duration-150
      transform
      w-full
      focus:ring-none
      focus:outline-none
      md:whitespace-nowrap
    "
    :disabled="disabled"
    :class="[`${extraClasses}`, isLoading ? 'pointer-events-none' : '']"
  >
    <div class="buttonInside">
      <div class="spinner" v-if="isLoading">
        <slot><LoadingSpinner :size="24" :labelButtonColor="true" :color="spinnerColor" /></slot>
      </div>
      <slot v-if="!isLoading">{{ label }}</slot>
    </div>
  </button>
</template>

<script lang="ts" setup>
import LoadingSpinner from '../../loading-spinner/LoadingSpinner.vue';
import { defineProps } from 'vue';

const white = '#fff'
const spinnerColor = 'var(--button-spinner-color, #D3D3D3)'

const props =
  defineProps<{
    disabled?: boolean;
    label?: string;
    isLoading?: boolean;
    extraClasses?: string;
  }>();
</script>
<style lang="scss" scoped>
.buttonNext {
  flex-direction: row;
  position: relative;
  justify-content: center;
  color: var(--button-label-color, var(--color-primary-contrast));

  &:hover {
    border-color: var(--button-border-hover-color, var(--button-border-color, rgba(0, 0, 0, 0)));
  }

  &:not(.noMaxW) {
    @media screen and (min-width: 640px) {
      max-width: 296px;
    }
  }

  &.modalBtn {
    color: var(--popup-button-label-color, var(--button-label-color, var(--color-primary-contrast)));
    background-color: var(--popup-button-background, var(--button-background, var(--color-primary)));

    &:hover {
      color: var(--popup-button-label-hover-color, var(--button-label-hover-color, var(--color-primary-contrast)));
      background: var(--popup-button-background-hover, var(--button-background-hover, var(--color-primary-shade)));
    }
  }

  &:not(.modalBtn) {
    border-width: 2px;
    transform: translateY(0);
    border-color: var(--button-border-color, rgba(0, 0, 0, 0));
    background-color: var(--button-background, var(--color-primary));
    border-radius: var(--button-corner-radius, 0.25rem);

    &:hover {
      color: var(--button-label-hover-color, var(--color-primary-contrast));
      background: var(--button-background-hover, var(--color-primary-shade));
    }

    &:disabled {
      filter: saturate(0);
      opacity: 0.5;
      background-color: var(--bg-color-dark);
      transform: translateY(0.25rem);
      pointer-events: none;
      cursor: not-allowed;
    }

    &:not(:disabled) {
      &:not(.noShadow) {
        box-shadow: 0 0 20px 5px var(--button-glow);
      }
    }
  }
}
.buttonInside {
  line-height: 24px;
  .spinner {
    justify-content: center;
    display: flex;
  }
}
</style>
